import { useParams } from "react-router-dom";
import { useCredentials } from "hooks/useCredentials";

export const useSlugCredential = () => {
   const { credentials, handleFetchCredentials } = useCredentials();
   const params = useParams();

   return {
      credential: credentials?.find((credential) => credential.id === params.slug),
      handleFetchCredentials
   };
};
